//import { Logger } from "./logger";
import { generateGuid } from "./helpers"

export class GAService
{
    static getGaSessionId() 
    {
        let randomNumberSession = Math.random() * 100000000;
        let sessionGuid = generateGuid();
        return sessionGuid + "." + randomNumberSession;
    }

    static getGaUserId() 
    {
        let randomNumberUser = Math.random() * 100000000; 
        let userGuid = generateGuid();
        return userGuid + "." + randomNumberUser;
    }
}



